<template>
  <div class="pattern-box" :style="{padding: padding}">
    <p class="left-top corner"></p>
    <p class="left-bottom corner"></p>
    <p class="right-top corner"></p>
    <p class="right-bottom corner"></p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name:"PatternBox",
  props:{
    padding:{
      type:String,
      default: "0.3rem 0.4rem 1.2rem"
    }
  }
}
</script>

<style lang="less" scoped>
.pattern-box{
  position: relative;
  width: 100%;
  border-radius: 0.2rem;
  min-height: 4.7rem;
  background: #ffffff;
  border: 1px solid #ffdaa2;
  // padding: 0.3rem 0.4rem 1.2rem;
  &+&{
    margin-top: 20px;
  }
  .corner{
    position: absolute;
    width: 1.2rem;
    height: 1.2rem;
    background: url("../assets/imgs/home/corner.png") no-repeat;
    background-size: contain;
  }
  .left-top{
    left: 0.2rem;
    top: 0.2rem;
  }
  .left-bottom{
    left: 0.2rem;
    bottom: 0.2rem;
    transform: rotate(-90deg);
  }
  .right-top{
    right: 0.2rem;
    top: 0.2rem;
    transform: rotate(90deg);
  }
  .right-bottom{
    right: 0.2rem;
    bottom: 0.2rem;
    transform: rotate(-180deg);
  }
}
</style>